import { auxiliaryFieldsDefaultValues, auxiliaryFieldsTransormers } from '../Filters/auxiliaryFields';
import { filterFields } from '../Filters/FilterFields/dataExplorerFieldsConfig';
import {
  EmptyPageQueryTransformer,
  FieldWithEmptyValueTransformer,
  GenericFieldTransformer,
  RangeFieldTransformer,
  DateTimeRangeFieldTransformer,
} from '../Filters/FieldTransformers/FieldTransformers';
import { regionDefaultValues, regionTransformers } from '../Filters/FilterFields/RegionGroup';
import { AllFieldsForm, FieldsForm } from './types';
import { commonFieldTransformers, getDefaultCommonDataFilterValues } from '../CommonDataFieldsSelector/CommonDataFieldsSelector';

export const fieldFiltersDefaultValues: FieldsForm = {
  search: filterFields.search.defaultValue,
  alphaCount: filterFields.alphaCount.defaultValue,
  type: filterFields.type.defaultValue,
  [filterFields.datasetId.name]: filterFields.datasetId.defaultValue,
  theme: filterFields.theme.defaultValue,
  dateCreated: filterFields.dateCreated.defaultValue,
  ...regionDefaultValues,
  ...auxiliaryFieldsDefaultValues,
  ...getDefaultCommonDataFilterValues(),
};

export const allFieldsListDefaultValues: AllFieldsForm = {
  ...fieldFiltersDefaultValues,
  category: filterFields.category.defaultValue,
  subcategory: filterFields.subcategory.defaultValue,
};

export const fieldFiltersTransformers = [
  new GenericFieldTransformer(filterFields.universe.name),
  new GenericFieldTransformer(filterFields.search.name),
  new RangeFieldTransformer(filterFields.alphaCount.name),
  new FieldWithEmptyValueTransformer(filterFields.type.name, filterFields.type.defaultValue),
  new EmptyPageQueryTransformer(filterFields.datasetId.name),
  new GenericFieldTransformer(filterFields.theme.name),
  new DateTimeRangeFieldTransformer(filterFields.dateCreated.name),
  ...commonFieldTransformers,
  ...regionTransformers,
  ...auxiliaryFieldsTransormers,
];

export const allFieldsFiltersTransformers = [
  ...fieldFiltersTransformers,
  new GenericFieldTransformer(filterFields.category.name),
  new GenericFieldTransformer(filterFields.subcategory.name),
];
